module.exports = __webpack_public_path__ + "img/logowhite.d887d53a.png";